import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Building2, CheckCircle2 } from "lucide-react";

export default function B2BRegister() {
  const { b2bRegister } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", full_name: "", company_name: "", tax_number: "", phone: "", address: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await b2bRegister(form);
      setDone(true);
      toast.success("Bayi başvurunuz alındı!");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Başvuru başarısız");
    } finally { setLoading(false); }
  };

  if (done) {
    return (
      <div className="kz-container py-20 max-w-lg text-center">
        <CheckCircle2 size={56} className="mx-auto text-green-600 mb-4"/>
        <h1 className="font-display text-3xl font-black mb-2">Başvurunuz Alındı</h1>
        <p className="text-ink-500 mb-6">Bayi başvurunuz incelenmek üzere yöneticilere iletildi. Onay sonrası size e-posta ile bildirim yapılacaktır.</p>
        <Link to="/hesabim" className="kz-btn-primary">Hesabıma Git</Link>
      </div>
    );
  }

  return (
    <div className="kz-container py-16 max-w-2xl">
      <div className="flex items-center gap-3 mb-2">
        <Building2 size={28} className="text-b2b"/>
        <h1 className="font-display text-3xl font-black">Bayi Başvurusu</h1>
      </div>
      <p className="text-ink-500 mb-8">İnşaat firmaları ve profesyonel ustalar için özel fiyatlandırma ve cari hesap imkânı.</p>
      <form onSubmit={submit} className="kz-card p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        <label className="block md:col-span-2">
          <span className="text-sm font-semibold mb-1 block">Firma Ünvanı</span>
          <input data-testid="b2b-company" required value={form.company_name} onChange={(e)=>setForm({...form, company_name: e.target.value})}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <label className="block">
          <span className="text-sm font-semibold mb-1 block">Vergi No</span>
          <input data-testid="b2b-tax" required value={form.tax_number} onChange={(e)=>setForm({...form, tax_number: e.target.value})}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <label className="block">
          <span className="text-sm font-semibold mb-1 block">Yetkili Kişi</span>
          <input required value={form.full_name} onChange={(e)=>setForm({...form, full_name: e.target.value})}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <label className="block">
          <span className="text-sm font-semibold mb-1 block">E-posta</span>
          <input data-testid="b2b-email" type="email" required value={form.email} onChange={(e)=>setForm({...form, email: e.target.value})}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <label className="block">
          <span className="text-sm font-semibold mb-1 block">Telefon</span>
          <input required value={form.phone} onChange={(e)=>setForm({...form, phone: e.target.value})}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <label className="block md:col-span-2">
          <span className="text-sm font-semibold mb-1 block">Adres</span>
          <textarea required rows={3} value={form.address} onChange={(e)=>setForm({...form, address: e.target.value})}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <label className="block md:col-span-2">
          <span className="text-sm font-semibold mb-1 block">Şifre</span>
          <input data-testid="b2b-password" type="password" required minLength={6} value={form.password} onChange={(e)=>setForm({...form, password: e.target.value})}
            className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
        </label>
        <button data-testid="b2b-submit" disabled={loading} className="kz-btn-primary md:col-span-2">
          {loading ? "Gönderiliyor..." : "Başvuruyu Gönder"}
        </button>
      </form>
    </div>
  );
}
